import { FC, ReactNode, useContext, useEffect } from "react";
import { ThemeProvider, themes } from "./shared/styled";
import { GlobalStyle } from "./shared/css";
import { TTheme } from "./shared/types";
import { useAppDispatch } from "./redux/hooks";
import { toggleTheme } from "./redux/slices/ui";
import { ThemeContext } from "./context/ThemeContextProvider";

const Theme: FC<{ children: ReactNode }> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { darkModeActive } = useContext(ThemeContext);
  const styledThemeName: TTheme = darkModeActive ? "dark" : "classic";

  useEffect(() => {
    dispatch(toggleTheme({ theme: styledThemeName }));
  }, [dispatch, styledThemeName]);

  return (
    <ThemeProvider theme={themes[styledThemeName]}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  );
};

export default Theme;
